import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaGuideStatusCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('guidesStatusModal.validation.descriptionRequired')),
  color: yup
    .string()
    .required(translate('guidesStatusModal.validation.colorRequired')),
});

export const schemaGuideStatusEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('guidesStatusModal.validation.descriptionRequired')),
  color: yup
    .string()
    .required(translate('guidesStatusModal.validation.colorRequired')),
  status: yup
    .boolean()
    .required(translate('guidesStatusModal.validation.statusRequired')),
});
